module.exports = __webpack_public_path__ + "static/media/file-certificate.038482c5.svg";